<template>
  <div 	
		class="factor" 
		@click="$emit('select', item)"
		:style="`border:1px solid ${item.isSelected ? $appColors.success : '#c5c5c5'}`"
		:class="{'isSelect': item.isSelected}">
		<v-layout class="column">
			<v-flex xs12 align-self-end>
				<v-icon
					color="success"
					:disabled="!item.isSelected"
				>
					check_circle
				</v-icon>
			</v-flex>
			<v-flex xs12>
				<img 
					:src="item.urlImage" 
					:lt="item.name">
				<hr class="factor-line" :style="`border: 0.5px solid ${$appColors.success};`">
				<p
					class="factor-text"
					:style="`color:${$appColors.info}`"
				>{{item.name}}</p>
			</v-flex>
		</v-layout>
	</div>
</template>
<script>
export default {
	name: 'factor',
	props: {
		item: {
			type: Object,
			default: () => {},
		},
	},
};
</script>

<style lang="scss" scoped>
	.factor {
		background: map-get($colors, white);
		border: 1px solid map-get($colors, gray-slider);
		border-radius: 4px;
		cursor: pointer;
		padding: 11px 11px 0px 24px;
		margin: 0 auto 12px;
		max-width: 159px;
		height: 152px;

		&:hover {
			border: 1px solid map-get($colors, success);
		}

		&-line {
			margin: 10px 0;
			width: 70%;
		}

		&-text {
			font-size: 11px;
			text-transform: uppercase;
		}
	}
</style>





// WEBPACK FOOTER //
// src/components/organizational/factor.vue